import React from "react";
import { Col, Row } from "react-bootstrap";
import { EditorMenu } from "./editor-menu";
import { EditorContent } from "./editor-content";

interface Props {
  viewMode: string;
}

const DocumentViewPreview = ({ viewMode }: Props) => {
  return (
    <Row>
      <Col sm={3} md={3} className={viewMode === "preview" ? "mt-1" : ""} style={{paddingLeft: 0}}>
        <div className="document-editor__menu fixed-menu">
          {/* <div className="d-flex align-items-center justify-content-center"> */}
          <EditorMenu />
          {/* </div> */}
        </div>
      </Col>
      <Col sm={9} md={9}>
        <div className={viewMode === "preview" ? "document-editor__content" : ""}>
          <EditorContent />
        </div>
      </Col>
    </Row>
  );
};

export default DocumentViewPreview;
